import React, { useEffect, useState } from "react";
import Switch from "react-switch";
import InfoCardComponent from "../Card/InfoCardComponent";
import TabComponent from "../Tab/TabComponent";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import { NumericFormat } from "react-number-format";
import {
  calculateEnbSavings,
  calculateIncreasePaymentCollection,
  calculateReduction,
  getReduceCostGoingPaperless,
  getStaffData,
} from "../../api/ApiService";
import useRoi from "../../Context/RoiContex";
import Savings from "../Card/StaffCostSavingsCard/Savings";
import { Bounce, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function FormOneCard() {
  const [providerValue, setProviderValue] = useState(0);
  const [providerSliderValue, setProviderSliderValue] = useState(0);

  const [monthlyAppointments, setMontlyAppointments] = useState(0);
  const [monthlyAppointmentsSliderValue, setMontlyAppointmentsSliderValue] = useState(0);

  const [patientVisits, setPatientVisits] = useState(0);
  const [patientVisitsSliderValue, setPatientVisitsSliderValue] = useState(0);

  const [ticketSize, setTicketSize] = useState(0);
  const [ticketSizeSliderValue, setTicketSizeSliderValue] = useState(0);

  const [checked, setChecked] = useState(false);
  const [staffDataLocalState, setstaffDataLocalState] = useState(null);
  const {
    updateProvider,
    updateMonthlyAppointments,
    updateNewPatientVisits,
    updatePatietnTicketSize,
    updateDigitalIntakeDependency,
    updateStaffData,
    saveStaffHoursInputValues,
    updateAutomatedSavingsData,
    reduceNoShowInputValue,
    updatePaymentCollectionData,
    paymentCollectionInputValue,
    updateNoShowData,
    updateCostGoingPaperLess,
    costGoingPaperless,
  } = useRoi();

  useEffect(() => {
    const getInitialData = async () => {
      try {
        const param = {
          numberOfProviders: parseInt(providerValue),
          monthlyAppointments: monthlyAppointments,
          percentageOfNewPatientsVisitMonth: patientVisits / 100,
          averageOrderValueEachPatientPerVisitOrPatientTicketSize: ticketSize,
          paperBasedIntakeDependency: checked,
        };
        const response = await getStaffData(param);
        updateStaffData(response);
        setstaffDataLocalState(response);

        if (checked) {
          const paramTwo = {
            monthlyAppointments: monthlyAppointments,
            percentageOfNewsPatientVisitMonth: patientVisits / 100,
            dependentPaperBaseIntake: checked,
          };
          const reducedCostGoingPaperLess = await getReduceCostGoingPaperless(paramTwo);
          updateCostGoingPaperLess(reducedCostGoingPaperLess);
        }
      } catch (error) {
        console.error("Error fetching staff data:", error);
        toast.error("Something went wrong!\nPlease try again later.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
          transition: Bounce,
        });
      } finally {
      }
    };
    setTimeout(() => {
      getInitialData();
    }, 100);
  }, [providerValue, monthlyAppointments, patientVisits, ticketSize, checked]);

  useEffect(() => {
    const getStaffSaveData = async () => {
      try {
        const param = {
          averageNumberOfHoursSpentInManualVerification:
            saveStaffHoursInputValues.avgEbVerificaitonPerMonth,
          perProviderCostEBServiceMonthly: saveStaffHoursInputValues.perProviderCost,
          numberOfProviders: providerValue,
        };
        const response = await calculateEnbSavings(param);
        updateAutomatedSavingsData(response);
        // setSavingsData(response);
      } catch (error) {
        console.error("Error fetching staff data:", error);
      } finally {
      }
    };
    setTimeout(() => {
      getStaffSaveData();
    }, 0);
  }, [providerValue]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const param1 = {
          averageOrderValueEachPatientPerVisitOrPatientTicketSize: parseInt(ticketSize),
          monthlyAppointments: monthlyAppointments,
          noShows: reduceNoShowInputValue / 100,
        };

        const param2 = {
          averageOrderValueEachPatientPerVisitOrPatientTicketSize: parseInt(ticketSize),
          monthlyAppointments: monthlyAppointments,
          percentOfBalanceRemainsUncollectedOrPlacedCollectionAgency:
            paymentCollectionInputValue / 100,
        };

        const [noShowResponse, paymentCollectionResponse] = await Promise.all([
          calculateReduction(param1),
          calculateIncreasePaymentCollection(param2),
        ]);

        // Update the state with the responses
        // setNoShowData(noShowResponse);
        updateNoShowData(noShowResponse);

        // setPaymentCollectionData(paymentCollectionResponse);
        const { additionalRevenue, annualIncrease } = paymentCollectionResponse;
        updatePaymentCollectionData({ additionalRevenue, annualIncrease });
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
      }
    };
  }, [, monthlyAppointments, ticketSize]);

  const handleSwitchChange = (checked) => {
    updateDigitalIntakeDependency(checked);
    setChecked(checked);
  };

  return (
    <div className="flex md:flex-row md:w-1/2 mx-auto p-4" id="main-body-container">
      <div className="shadow-md w-full mx-auto sm:mx-0" id="main-body-container-first">
        <div className="gap-3 px-2 ">
          <div className="flex flex-col  gap-1 mb-4 text-custom-margin">
            <div className="font-semibold text-2xl  bg-[#9c9c9c] rounded-2xl  mb-2">
              <h2 className="text-white text-center w-full">1. Streamline Patient Intake </h2>
            </div>
            <div className="flex justify-between h-[62px] items-center">
              <label htmlFor="no-of-provider" className="text-lg text-[#1A1A1A] font-semibold">
                Number of full-time providers in my practice
              </label>
              <input
                type="number"
                name="provider"
                id="no-of-provider"
                value={providerValue}
                className="ha-roi-form-input"
                onChange={(event) => {
                  setProviderValue(event.target.value);
                  setProviderSliderValue(event.target.value);
                  updateProvider(parseInt(event.target.value));
                }}
              />
            </div>
            <Slider
              min={0}
              max={1000}
              value={providerSliderValue}
              trackStyle={{ backgroundColor: "#147D6E" }}
              handleStyle={{
                borderColor: "#147D6E",
                backgroundColor: "#147D6E",
              }}
              onChange={(value) => {
                setProviderSliderValue(value);
                setProviderValue(value);
              }}
            />
          </div>
          <div className="flex flex-col  gap-1 mb-4 text-custom-margin">
            <div className="flex justify-between h-[62px] items-center">
              <label
                htmlFor="monthly-appointments"
                className="text-lg text-[#1A1A1A] font-semibold"
              >
                Number of appointments per month
              </label>
              <input
                type="number"
                name="monthly-appointments"
                id="monthly-appointments"
                value={monthlyAppointments}
                className="ha-roi-form-input"
                onChange={(event) => {
                  updateMonthlyAppointments(event.target.value);
                  setMontlyAppointments(event.target.value);
                  setMontlyAppointmentsSliderValue(event.target.value);
                }}
              />
            </div>
            <Slider
              min={0}
              max={10000}
              value={monthlyAppointmentsSliderValue}
              trackStyle={{ backgroundColor: "#147D6E" }}
              handleStyle={{
                borderColor: "#147D6E",
                backgroundColor: "#147D6E",
              }}
              onChange={(value) => {
                updateMonthlyAppointments(value);
                setMontlyAppointmentsSliderValue(value);
                setMontlyAppointments(value);
              }}
            />
          </div>
          <div className="flex flex-col  gap-1 mb-4 text-custom-margin">
            <div className="flex justify-between h-[62px] items-center">
              <label htmlFor="patients-visits" className="text-lg text-[#1A1A1A] font-semibold">
                Percentage of new patients per month
              </label>
              <NumericFormat
                id="patients-visits"
                name="patients-visits"
                value={patientVisits}
                className="ha-roi-form-input"
                onValueChange={(values) => {
                  const { value } = values;
                  updateNewPatientVisits(value);
                  setPatientVisits(value);
                  setPatientVisitsSliderValue(value);
                }}
                suffix="%"
                allowNegative={false}
              />
            </div>
            <Slider
              min={0}
              max={100}
              value={patientVisitsSliderValue}
              trackStyle={{ backgroundColor: "#147D6E" }}
              handleStyle={{
                borderColor: "#147D6E",
                backgroundColor: "#147D6E",
              }}
              onChange={(value) => {
                setPatientVisitsSliderValue(value);
                setPatientVisits(value);
              }}
            />
          </div>
          <div className="flex flex-col  gap-1 mb-4 text-custom-margin">
            <div className="flex justify-between h-[62px] items-center">
              <label
                htmlFor="average-patient-ticket-size"
                className="text-lg text-[#1A1A1A] font-semibold"
              >
                Average fee per visit for a patient
              </label>

              <NumericFormat
                id="average-patient-ticket-size"
                thousandSeparator={true}
                decimalScale={0}
                fixedDecimalScale={true}
                allowNegative={false}
                value={ticketSize}
                max={5000}
                prefix="$"
                className="ha-roi-form-input"
                onValueChange={(values) => {
                  const { value } = values;
                  updatePatietnTicketSize(value);
                  setTicketSize(value);
                  setTicketSizeSliderValue(value);
                }}
              />
            </div>
            <Slider
              min={0}
              max={1000}
              value={ticketSizeSliderValue}
              trackStyle={{ backgroundColor: "#147D6E" }}
              handleStyle={{
                borderColor: "#147D6E",
                backgroundColor: "#147D6E",
              }}
              onChange={(value) => {
                setTicketSize(value);
                setTicketSizeSliderValue(value);
              }}
            />
          </div>
          <div className="flex justify-between h-[62px] items-center text-custom-margin">
            <label htmlFor="digital-intake" className="text-lg text-[#1A1A1A] font-semibold">
              Are you using a paper-based process for intake currently?
            </label>
            <Switch
              checked={checked}
              width={70}
              offColor="#CCCCCC"
              onColor="#147D6E"
              onHandleColor="#FFF"
              onChange={handleSwitchChange}
              uncheckedIcon={
                <div
                  className=""
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                    fontSize: 15,
                    fontWeight: 700,
                  }}
                >
                  No
                </div>
              }
              checkedIcon={
                <div
                  className="text-white "
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                    fontSize: 15,
                    fontWeight: 700,
                  }}
                >
                  Yes
                </div>
              }
            />
          </div>
          {staffDataLocalState && (
            <Savings
              props={staffDataLocalState}
              costGoingPaperLess={costGoingPaperless}
              isUsingDigitalIntakePlatform={checked}
            />
          )}

          {/* <InfoCardComponent /> */}
        </div>

        <ToastContainer />
      </div>
      <TabComponent />
    </div>
  );
}

export default FormOneCard;
